module.exports = __webpack_public_path__ + "static/media/4ODA18.659546c6.jpg";